import React from "react";
import { Box, Divider, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import ShowSingleChat from "./ShowSingleChat";
import { useAppContext } from "src/hooks";
import { useLocation, useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import {
  _getChatMessages,
  _addUserInChatList,
  _seenMessages,
  _getAllChats,
} from "src/DAL";
import { del_from_local_storage, get_from_localStorage } from "src/utils";
import {
  del_from_sessionStorage,
  get_from_sessionStorage,
} from "src/utils/sessionStorage";
import { Iconify, Scrollbar, MenuPopover } from "src/components";
import ChatListSidebar from "./ChatListSidebar";

export default function ChatNotificationDialog({ setAnchorEl, anchorEl }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const {
    currentChat,
    setCurrentChat,
    chatList,
    setChatListDrawerOpen,
    messageCount,
    setMessageList,
    setMessageCount,
    setChatList,
    messageListPageNo,
    setMessageListPageNo,
    isOpenChatDialog,
    setChatType,
    setChatCount,
    setIsOpenChatDialog,
    isOpenChatNotificationDialog,
    setIsOpenChatNotificationDialog,
    chatType,
    isMinimizeChat,
    getModifiedChatItem,
    dispatch_get_user_profile,
    chatData,
    setChatData,
    badge,
    setBadge,
    chatCount,
    socketEmit,
    setLoadingMessageList,
    loadingMessageList,
    chatListLoading,
    setChatListLoading,
  } = useAppContext();
  const [chatListPage, setChatListPage] = useState(0);
  const [isAddChatDrawerOpen, setIsAddChatDrawerOpen] = useState(false);

  const [isMobile, setIsMobile] = useState(
    window.innerWidth > 768 ? false : true
  );

  useEffect(() => {
    // setIsOpenChatDialog(false);
    window.addEventListener("resize", () => {
      if (window.innerWidth > 768) {
        setIsMobile(false);
      } else {
        setIsMobile(true);
      }
      return () => {
        removeEventListener("resize");
      };
    });
  }, []);

  const handleClose = () => {
    setAnchorEl(null);
    setIsOpenChatNotificationDialog(false);
  };

  const modifiedChatList = (list) => {
    const modified = list.map((chat) => {
      return { ...getModifiedChatItem(chat) };
    });
    return [...modified];
  };

  const getChatsList = async (type) => {
    setChatListLoading(true);
    try {
      const result = await _getAllChats(0, 15);
      if (result.code == 200) {
        console.log(result, "chat list response result?");

        let tempChatList = modifiedChatList(result.chat_list.chat_list);
        tempChatList.sort((a, b) => {
          const dateA = new Date(a.last_message?.createdAt || 0);
          const dateB = new Date(b.last_message?.createdAt || 0);
          return dateB - dateA;
        });
        if (currentChat) {
          let temp = tempChatList.findIndex(
            (chat) => chat._id == currentChat._id
          );
          if (temp == -1) {
            tempChatList.unshift(currentChat);
          } else {
            setCurrentChat(tempChatList[temp]);
          }
        }
        console.log("chatlist updated no: 25");
        setChatList(tempChatList);
        setChatCount(result.chat_list.chat_list_count);
        setChatListPage((prev) => prev + 1);
      } else {
        enqueueSnackbar(result.message, { variant: "error" });
      }
    } catch (error) {
      enqueueSnackbar("Something went wrong!", { variant: "error" });
      console.log(error, "error catched");
    } finally {
      setChatListLoading(false);
    }
  };

  const getMessageList = async (chat) => {
    setLoadingMessageList(true);
    try {
      const result = await _getChatMessages(chat._id);
      if (result.code == 200) {
        setChatData(result.message.chat_data);
        setMessageList(result.message.message_list);
        setMessageCount(result.message.message_count);
        setMessageListPageNo((prev) => prev + 1);
        const res = await _seenMessages(chat._id);
        if (res.code == 200) {
          console.log("Calling seen message socket event");

          let receivers = chat.member_user;
          let receviverIds = receivers?.map((member) => {
            return member.user_id;
          });
          socketEmit("on_message_read", {
            chat_id: chat._id,
            receivers_id: receviverIds,
          });
          socketEmit("send_unread_count", {
            user_id: dispatch_get_user_profile().user_id,
          });
        } else {
          console.log("Failed to call seen message API: ", res.message);
        }

        // console.log(result.message.chat_data, "dkkkkkkkkkkkkkkkkkkkkk.....................");
      } else if (
        result.message == "Cannot read properties of null (reading 'type')"
      ) {
        setCurrentChat();
        del_from_sessionStorage("currentChat");
        console.log("chatlist updated no: 26");
        setChatList((prev) =>
          prev.filter((prevChat) => prevChat._id !== chat._id)
        );
      } else {
        enqueueSnackbar(result.message, { variant: "error" });
      }
    } catch (error) {
      enqueueSnackbar("Something went wrong!", { variant: "error" });
      console.log(error, " error catched");
    } finally {
      setLoadingMessageList(false);
    }
  };

  const loadMoreChats = async () => {
    try {
      if (chatType == "all") {
        const result = await _getAllChats(chatListPage, 15);
        if (result.code == 200) {
          let tempChatList = chatList.concat(
            modifiedChatList(result.chat_list.chat_list)
          );
          const uniqueArray = tempChatList.reduce((accumulator, current) => {
            const isDuplicate = accumulator.find(
              (item) => item._id === current._id
            );
            if (!isDuplicate) {
              return [...accumulator, current];
            }
            return accumulator;
          }, []);
          // setChatList((prev) => {
          //   return prev.concat(modifiedChatList(result.chat_list.chat_list));
          // });
          console.log("chatlist updated no: 27");
          setChatList(uniqueArray);
          setChatCount(result.chat_list.chat_list_count);
          setChatListPage((prev) => prev + 1);
        } else {
          enqueueSnackbar(result.message, { variant: "error" });
        }
      } else if (chatType == "groups") {
        const result = await _getGroupChatList(chatListPage, 15);
        if (result.code == 200) {
          console.log("chatlist updated no: 28");
          setChatList((prev) => {
            return prev.concat(
              modifiedChatList(result.group_list.group_chat_list)
            );
          });
          setChatCount(result.group_list.group_chat_list_count);
        } else {
          enqueueSnackbar(result.message, { variant: "error" });
        }
      }
    } catch (error) {
      enqueueSnackbar("Something went wrong!", { variant: "error" });
      console.log(error, "error catched");
    } finally {
      setChatListLoading(false);
    }
  };

  const onChatClick = (chat) => {
    console.log(chat, "Clicked Chat");
    const unreadCount = chat.unread_count || 0;

    setCurrentChat({
      ...chat,
    });
    setMessageListPageNo(0);
    setMessageCount(0);
    setMessageList([]);
    setChatData();
    getMessageList(chat);
    console.log("chatlist updated no: 29");
    setChatList((prev) => {
      return prev.map((cht) => {
        if (chat._id == cht._id) {
          return { ...cht, unread_count: 0 };
        } else {
          return { ...cht };
        }
      });
    });
    setChatListDrawerOpen(false);

    setBadge((prev) => {
      return { ...prev, chat: Math.max(prev.chat - unreadCount, 0) };
    });
    setIsOpenChatNotificationDialog(false);
    if (pathname.startsWith("/chats")) {
      // If already on the same chat, don't navigate but still update state
      if (pathname === `/chats/${chat._id}`) {
        // Already viewing this chat, just update the current chat state
        setCurrentChat({
          ...chat,
          unread_count: 0,
        });
      } else {
        navigate(`/chats/${chat._id}`);
      }
    } else {
      if (isMobile) {
        navigate("/chats");
      } else {
        setIsAddChatDrawerOpen(true);
      }
    }
  };

  useEffect(() => {
    if (chatList.length == 0) {
      console.log("chatlist updated no: 30");
      setChatList([]);
      setChatCount(0);
      setChatListPage(0);
      getChatsList("all");
    }
  }, [chatType, isOpenChatNotificationDialog]);

  return (
    <MenuPopover
      open={isOpenChatNotificationDialog}
      anchorEl={anchorEl}
      onClose={handleClose}
      sx={{ width: 360 }}
      className="mt-5"
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      transformOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      <Box className="d-flex align-items-center py-2 px-3">
        <Box sx={{ flexGrow: 1 }}>
          <Typography variant="subtitle1">Massages</Typography>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            You have {badge.chat} unread Messages
          </Typography>
        </Box>
      </Box>
      <Divider sx={{ borderStyle: "dashed" }} />
      <div className="p-3">
        <ChatListSidebar
          chatType={chatType}
          onChatClick={onChatClick}
          setChatType={setChatType}
          chatListLoading={chatListLoading}
          chatCount={chatCount}
          chatList={chatList}
          setChatList={setChatList}
          chatListPage={chatListPage}
          currentChat={currentChat}
          setCurrentChat={setCurrentChat}
          loadMoreChats={loadMoreChats}
          setIsAddChatDrawerOpen={setIsAddChatDrawerOpen}
          isMinHeight={true}
        />
      </div>
    </MenuPopover>
  );
}
